<template>
  <div
    :class="{ 'matching-filters--closed': !filtersOpened }"
    class="matching-filters"
  >
    <div class="matching-filters__toggle-wrapper">
      <div class="matching-filters__filters-wrapper">
        <span class="matching-filters__filters-title">Filters</span>
        <div
          style="
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            gap: 8px;
          "
        >
          <ElDropdown placement="bottom-start" :hide-on-click="false">
            <ElTag type="primary" effect="plain">Level (VIL)</ElTag>
            <template #dropdown>
              <ElDropdownMenu>
                <ElDropdownItem>
                  <div class="slider-demo-block">
                    <ElSlider
                      v-model="vilLevel"
                      :max="6"
                      :min="1"
                      :step="1"
                      range
                      show-stops
                      :marks="{
                        1: '1',
                        2: '2',
                        3: '3',
                        4: '4',
                        5: '5',
                        6: '6',
                      }"
                    />
                  </div>
                </ElDropdownItem>
              </ElDropdownMenu>
            </template>
          </ElDropdown>

          <ElDropdown placement="bottom-start" :hide-on-click="false">
            <ElTag type="primary" effect="plain">
              HQ Country
              {{
                country_filter_count > 0 ? "(" + country_filter_count + ")" : ""
              }}
            </ElTag>
            <template #dropdown>
              <ElDropdownMenu>
                <ElDropdownItem
                  v-for="facet in $store.state.matchingSearch.facets.countries
                    ?.options"
                  :key="facet.value"
                >
                  <ElCheckbox
                    :key="facet.value"
                    :label="`${facet.label} (${facet.count})`"
                    :model-value="
                      $store.state.matchingSearch.filters.countries.includes(
                        facet.value,
                      )
                    "
                    @change="onHQCountryChange(facet.value)"
                  />
                </ElDropdownItem>
                <div
                  divider
                  style="
                    display: flex;
                    justify-content: flex-end;
                    gap: 8px;
                    padding-top: 10px;
                    padding-bottom: 10px;
                  "
                >
                  <ElTag type="danger" @click="onHQCountryChange('clear')">
                    Clear All
                  </ElTag>

                  <ElTag type="danger" @click="onHQCountryChange('all')">
                    Select All
                  </ElTag>
                </div>
              </ElDropdownMenu>
            </template>
          </ElDropdown>

          <ElDropdown placement="bottom-start" :hide-on-click="false">
            <ElTag type="primary" effect="plain">
              Sectors
              {{
                sector_filter_count > 0 ? "(" + sector_filter_count + ")" : ""
              }}
            </ElTag>
            <template #dropdown>
              <ElDropdownMenu>
                <ElDropdownItem
                  v-for="facet in $store.state.matchingSearch.facets.sectors
                    ?.options"
                  :key="facet.value"
                >
                  <ElCheckbox
                    :label="`${facet.label} (${facet.count})`"
                    :value="facet.value"
                    :model-value="
                      $store.state.matchingSearch.filters.sectors?.includes(
                        facet.value,
                      )
                    "
                    @change="onSectorsChange(facet.value)"
                  />
                </ElDropdownItem>
                <ElDropdownItem
                  divider
                  style="
                    display: flex;
                    justify-content: flex-end;
                    gap: 8px;
                    padding-top: 10px;
                    padding-bottom: 10px;
                  "
                >
                  <ElTag type="danger" @click="onSectorsChange('all')">
                    Clear All
                  </ElTag>

                  <ElTag type="danger" @click="onSectorsChange('all')">
                    Select All
                  </ElTag>
                </ElDropdownItem>
              </ElDropdownMenu>
            </template>
          </ElDropdown>

          <ElDropdown placement="bottom-start" :hide-on-click="false">
            <ElTag type="primary" effect="plain">
              Founded Date
              {{
                founding_date_filter_count > 0
                  ? "(" + founding_date_filter_count + ")"
                  : ""
              }}
            </ElTag>
            <template #dropdown>
              <ElDropdownMenu>
                <ElDropdownItem
                  v-for="facet in founding_date_facet"
                  :key="facet.value"
                >
                  <ElCheckbox
                    :label="`${Math.abs(Number(facet.value)) === 0 ? 'No Founding Date' : facet.value} (${facet.count})`"
                    :value="facet.value"
                    :model-value="
                      $store.state.matchingSearch.filters.founding_date?.includes(
                        facet.value,
                      )
                    "
                    @change="onFoundingDateChange(facet.value)"
                  />
                </ElDropdownItem>
                <ElDropdownItem
                  divider
                  style="
                    display: flex;
                    justify-content: flex-end;
                    gap: 8px;
                    padding-top: 10px;
                    padding-bottom: 10px;
                  "
                >
                  <ElTag type="danger" @click="onSectorsChange('all')">
                    Clear All
                  </ElTag>

                  <ElTag type="danger" @click="onSectorsChange('all')">
                    Select All
                  </ElTag>
                </ElDropdownItem>
              </ElDropdownMenu>
            </template>
          </ElDropdown>

          <ElTag style="cursor: pointer" type="danger" @click="clearAllFilters">
            Clear all filters
          </ElTag>
        </div>
        <div class="matching-filters__search-wrapper">
          <ElInput
            v-if="hasCompaniesSearch"
            v-model="query"
            class="matching-filters__search"
            clearable
            placeholder="Search for a name, country & sector"
          >
            <!-- :placeholder="$t('matching.matchingList.companiesSelector')" -->
            <template #prefix>
              <PxIcon :size="24" name="magnifier" />
            </template>
          </ElInput>
          <ElDropdown placement="bottom-start">
            <ElTag type="primary" effect="plain">
              Sort By ({{ sort === "desc" ? "Latest First" : "Oldest First" }})
            </ElTag>
            <template #dropdown>
              <ElDropdownMenu>
                <ElDropdownItem @click="onSortChange('desc')">
                  Latest First
                </ElDropdownItem>
                <ElDropdownItem @click="onSortChange('asc')">
                  Oldest First
                </ElDropdownItem>
              </ElDropdownMenu>
            </template>
          </ElDropdown>
          <PxButton
            v-if="$user.isSupporter() && $screen.mdDown"
            :icon="$options.static.editCriteriaButton.icon"
            :size="$options.static.editCriteriaButton.size"
            :type="$options.static.editCriteriaButton.type"
            :variant="$options.static.editCriteriaButton.variant"
            class="matching-filters__toggle-button"
            @click="onClickEditCriteria"
          />
        </div>
      </div>
    </div>
  </div>
  <div v-show="filtersOpened" class="matching-filters__wrapper">
    <ElForm v-if="$screen.mdUp" ref="filters" :model="filters">
      <div class="form-grid form-grid--centered">
        <ElFormItem prop="networks">
          <div class="matching-filters__label">
            <span>
              {{ $t(`matching.matchingFilters.networks.label`) }}
            </span>
            <ElTooltip
              placement="top"
              popper-class="matching-filters__tooltip el-abaca-tooltip"
            >
              <template #content>
                <div v-html="$t('matching.matchingFilters.networks.tip')" />
              </template>
              <PxIcon
                :size="16"
                class="matching-filters__tooltip-icon"
                name="question"
              />
            </ElTooltip>
          </div>
          <NetworksSelector
            ref="networkSelector"
            v-model="filters.network.values"
            :no-label="true"
            :no-location="true"
            :placeholder-copy="
              $t(`matching.matchingFilters.networks.placeholder`)
            "
            :value-as-instance="true"
            class="matching-filters__selector"
          />
        </ElFormItem>
      </div>
    </ElForm>
    <PxFormModal
      v-else
      :title="filtersTitle"
      :visibility="filtersOpened"
      @close="toggleFilters"
    >
      <template #form>
        <ElForm ref="filters" :model="filters">
          <ElFormItem
            :label="$t(`matching.matchingFilters.networks.label`)"
            prop="networks"
          >
            <NetworksSelector
              ref="networkSelector"
              v-model="filters.network.values"
              :is-modal="true"
              :no-label="true"
              :placeholder-copy="
                $t(`matching.matchingFilters.networks.placeholder`)
              "
              :value-as-instance="true"
              class="matching-filters--mobile__selector"
            />
          </ElFormItem>
        </ElForm>
      </template>
    </PxFormModal>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import clone from "lodash/clone";
import isEqual from "lodash/isEqual";
import debounce from "lodash/debounce";
import cloneDeep from "lodash/cloneDeep";

import store from "@/services/store";
import { extractValuesFromFilter } from "@/modules/matching/components/matching-filters/matching-filters.utils";

import NetworksSelector from "@/components/networks-selector/networks-selector.vue";
import { INetwork } from "@/services/data/network/network.interface";
import { EPxButtonSize } from "@/components/px-button/px-button.types";
import { EPxButtonType } from "@/components/px-button/px-button.types";
import { IMatchingFilters } from "@/mixins/matching-list.mixin";
import { EPxButtonVariant } from "@/components/px-button/px-button.types";
import {
  EMatchingSearchActions,
  IFacet,
} from "../../services/store/matching-search/matching-search.types";
import { MATCHING_SELECTED_FILTERS } from "@/modules/matching/constants";
import { EMetaActions, EMetaGetters } from "@/services/store/meta/meta-types";
import { IMatchingQueryFiltersParams } from "@/modules/matching/components/matching-filters/mathing-filters.interface";
import { MATCHING_HAS_SYNCED_FILTERS } from "@/modules/matching/constants";
import { AFFILIATE_SUPPORTER_PROGRAM_UPDATE_URL } from "@/modules/affiliates/constants";

export default defineComponent({
  name: "MatchingFilters",

  components: {
    NetworksSelector,
  },

  props: {
    hasCompaniesSearch: {
      type: Boolean,
      default: false,
    },
  },

  static: {
    editCriteriaButton: {
      icon: "icon-gear--grey",
      size: EPxButtonSize.SMALL,
      type: EPxButtonType.GHOST_GREY,
      variant: EPxButtonVariant.COMPACT,
    },
  },

  data() {
    return {
      query: "",
      sort: "desc",
      filtersOpened: false,
      vilLevel: [2, 6],
      filters: {
        name: {
          value: "",
          onlyOnDiscover: true,
        },
        network: {
          key: "slug",
          values: [] as INetwork[],
        },
      } as IMatchingFilters,
    };
  },

  computed: {
    founding_date_facet(): any {
      const options =
        this.$store.state.matchingSearch.facets?.founding_date?.options;

      if (!options || options.length === 0) {
        return [];
      }

      return options.sort((a, b) => Number(a.value) - Number(b.value));
    },
    country_filter_count(): number {
      return this.$store.state.matchingSearch.filters.countries?.length ?? 0;
    },
    sector_filter_count(): number {
      return this.$store.state.matchingSearch.filters.sectors?.length ?? 0;
    },
    founding_date_filter_count(): number {
      return (
        this.$store.state.matchingSearch.filters.founding_date?.length ?? 0
      );
    },
    facets(): any {
      return this.$store.state.matchingSearch.facets;
    },

    selectedFilters(): IMatchingFilters | null {
      return (
        this.$store.getters[EMetaGetters.GET](MATCHING_SELECTED_FILTERS) || null
      );
    },

    hasSelectedFilters(): boolean {
      return (
        !!this.selectedFilters &&
        Object.keys(this.selectedFilters)
          .map((k: any) => (this.selectedFilters as IMatchingFilters)[k])
          .some((k: any) => !!k?.values?.length)
      );
    },

    availableQueryParams(): Array<string> {
      return Object.keys(this.filters);
    },

    joinedFiltersParams() {
      const filterParams: { [key: string]: string } = {};

      Object.entries(this.filters).forEach(([key, filter]) => {
        const filterValues = extractValuesFromFilter(filter);
        filterParams[key] = filterValues.join(",");
      });

      return filterParams;
    },

    splittedQueryFilterParams(): IMatchingQueryFiltersParams | null {
      const queryFilters: IMatchingQueryFiltersParams = {};

      this.availableQueryParams.forEach((param: string) => {
        if (param in this.$route.query) {
          const joinedQueryValues = this.$route.query[param] as string;
          queryFilters[param] = joinedQueryValues.split(",");
        }
      });

      return Object.keys(queryFilters).length ? queryFilters : null;
    },

    equalQueryParamsAndFilters(): boolean {
      let areEqual = true;

      for (const filter in this.joinedFiltersParams) {
        if (
          Object.prototype.hasOwnProperty.call(this.joinedFiltersParams, filter)
        ) {
          const filterValues = this.joinedFiltersParams[filter].split(",");

          if (!areEqual) {
            break;
          }

          if (
            this.splittedQueryFilterParams &&
            filter in this.splittedQueryFilterParams
          ) {
            areEqual = isEqual(
              this.splittedQueryFilterParams[filter],
              filterValues,
            );
          }
        }
      }

      return areEqual;
    },

    hasFilters(): boolean {
      return (
        this.filters &&
        Object.keys(this.filters)
          .map((k: any) => this.filters[k])
          .some((k: any) => !!k?.values?.length)
      );
    },

    hasSearchTerm(): boolean {
      return !!this.filters?.name?.value;
    },

    filtersLength(): number {
      return Object.keys(this.filters)
        .map((k: any) => this.filters[k])
        .reduce(
          (total: number, current: any) => total + current?.values?.length || 0,
          0,
        );
    },

    filtersTitle(): string {
      return `${this.$t("matching.matchingFilters.toggleButton")} ${
        this.hasFilters ? `(${this.filtersLength})` : ""
      }`;
    },
  },

  watch: {
    vilLevel: {
      handler: debounce(async function (this: any, newValues: any) {
        this.$store.dispatch(EMatchingSearchActions.SET_FILTERS, {
          ...this.$store.state.matchingSearch.filters,
          vil: newValues,
        });
        const result = await this.$store.dispatch(
          EMatchingSearchActions.SEARCH,
          "search",
        );
        this.$emitter.emit("search-completed", { status: result });
      }, 600),
    },

    query: {
      deep: true,
      handler: debounce(async function (this: any, newValues: any) {
        await this.$store.dispatch(EMatchingSearchActions.SET_FILTERS, {
          ...this.$store.state.matchingSearch.filters,
          query: newValues,
        });
        const result = await this.$store.dispatch(
          EMatchingSearchActions.SEARCH,
          "search",
        );
        this.$emitter.emit("search-completed", { status: result });
      }, 600),
    },

    sort: {
      deep: true,
      handler: debounce(async function (this: any, newValues: any) {
        this.$store.dispatch(EMatchingSearchActions.SET_FILTERS, {
          ...this.$store.state.matchingSearch.filters,
          sort: newValues,
        });

        const result = await this.$store.dispatch(
          EMatchingSearchActions.SEARCH,
          "search",
        );
        this.$emitter.emit("search-completed", { status: result });
      }, 600),
    },

    filters: {
      deep: true,
      handler: debounce(function (this: any, newValues: IMatchingFilters) {
        const newSelection = newValues ? cloneDeep(newValues) : null;
        this.onFiltersChangeHandler(newSelection);
      }, 600),
    },

    equalQueryParamsAndFilters(areSynced: boolean) {
      this.$store.dispatch(EMetaActions.SET, {
        key: MATCHING_HAS_SYNCED_FILTERS,
        value: areSynced,
      });
    },

    hasFilters(hasFilters: boolean) {
      // Open all selected filters on desktop
      if (hasFilters && this.$screen.mdUp) {
        this.filtersOpened = hasFilters;
      }

      // Emit event to inform parent component if either there are filters or search term defined or not
      this.$emit("has-filters-change", hasFilters || this.hasSearchTerm);
    },

    hasSearchTerm(hasSearchTerm: boolean) {
      // Emit event to inform parent component if either there are filters or search term defined or not
      this.$emit("has-filters-change", hasSearchTerm || this.hasFilters);
    },
  },

  created() {
    // this.prefillFilters();
    // this.$store.dispatch(EMatchingSearchActions.SEARCH);
  },

  methods: {
    isSelected(value: any) {
      const v =
        this.$store.state.matchingSearch.filters.countries.includes(value);
      console.log("isSelected", v);
      return v;
    },
    onSortChange(value: string) {
      this.sort = value;
    },

    async clearAllFilters() {
      console.log("hello");
      // this.query = "";
      this.$store.dispatch(EMatchingSearchActions.SET_FILTERS, {
        level: [1, 6],
        countries: [],
        sectors: [],
        foundedYear: [],
        query: "",
      });
      const result = await this.$store.dispatch(
        EMatchingSearchActions.SEARCH,
        "search",
      );
      this.$emitter.emit("search-completed", { status: result });
    },

    setQuery(query: { [key: string]: any }) {
      const obj = Object.assign({}, this.$route.query);

      Object.keys(query).forEach((key: any) => {
        const value = query[key];
        if (value) {
          obj[key] = value;
        } else {
          delete obj[key];
        }
      });

      if (isEqual(this.$route.query, obj)) {
        return;
      }

      this.$router.replace({
        ...this.$router.currentRoute.value,
        query: obj,
      });
    },

    removeQuery(queryNameArray: Array<string>) {
      const obj: { [key: string]: any } = {};
      queryNameArray.forEach((key: any) => {
        obj[key] = null;
      });
      this.setQuery(obj);
    },

    onFiltersChangeHandler(newFilters: IMatchingFilters | null) {
      if (newFilters) {
        this.setQuery(this.joinedFiltersParams);
        this.$store.dispatch(EMetaActions.SET, {
          key: MATCHING_SELECTED_FILTERS,
          value: newFilters,
        });
      } else {
        this.removeQuery(this.availableQueryParams);
        this.$store.dispatch(EMetaActions.REMOVE, MATCHING_SELECTED_FILTERS);
      }
    },

    prefillFilters() {
      store.dispatch(EMatchingSearchActions.LOAD_FACETS);
      if (this.selectedFilters) {
        this.filters = clone(this.selectedFilters);
      }

      // Open all selected filters on desktop
      if (this.hasSelectedFilters && this.$screen.mdUp) {
        this.filtersOpened = true;
      }
    },

    toggleFilters() {
      this.filtersOpened = !this.filtersOpened;
      (this as any).$refs.toggleBtn.$el.blur();
    },

    onClickEditCriteria() {
      window.open(AFFILIATE_SUPPORTER_PROGRAM_UPDATE_URL);
    },

    async onHQCountryChange(value: string) {
      if (value === "all") {
        this.$store.dispatch(EMatchingSearchActions.SET_FILTERS, {
          ...this.$store.state.matchingSearch.filters,
          countries: this.$store.state.matchingSearch.facets[
            "countries"
          ].options.map((item: any) => item.value),
        });
      } else if (value === "clear") {
        this.$store.dispatch(EMatchingSearchActions.SET_FILTERS, {
          ...this.$store.state.matchingSearch.filters,
          countries: [],
        });
      } else {
        if (
          this.$store.state.matchingSearch.filters.countries.includes(value)
        ) {
          this.$store.dispatch(EMatchingSearchActions.SET_FILTERS, {
            ...this.$store.state.matchingSearch.filters,
            countries:
              this.$store.state.matchingSearch.filters.countries.filter(
                (item) => item !== value,
              ),
          });
        } else {
          this.$store.dispatch(EMatchingSearchActions.SET_FILTERS, {
            ...this.$store.state.matchingSearch.filters,
            countries: [
              ...this.$store.state.matchingSearch.filters.countries,
              value,
            ],
          });
        }
      }

      const result = await this.$store.dispatch(
        EMatchingSearchActions.SEARCH,
        "search",
      );
      this.$emitter.emit("search-completed", { status: result });
    },
    async onSectorsChange(value: string) {
      if (this.$store.state.matchingSearch.filters.sectors.includes(value)) {
        this.$store.dispatch(EMatchingSearchActions.SET_FILTERS, {
          ...this.$store.state.matchingSearch.filters,
          sectors: this.$store.state.matchingSearch.filters.sectors.filter(
            (item) => item !== value,
          ),
        });
      } else {
        this.$store.dispatch(EMatchingSearchActions.SET_FILTERS, {
          ...this.$store.state.matchingSearch.filters,
          sectors: [...this.$store.state.matchingSearch.filters.sectors, value],
        });
      }

      const result = await this.$store.dispatch(
        EMatchingSearchActions.SEARCH,
        "search",
      );
      this.$emitter.emit("search-completed", { status: result });
    },
    async onFoundingDateChange(value: number) {
      if (
        this.$store.state.matchingSearch.filters.founding_date.includes(value)
      ) {
        this.$store.dispatch(EMatchingSearchActions.SET_FILTERS, {
          ...this.$store.state.matchingSearch.filters,
          founding_date:
            this.$store.state.matchingSearch.filters.founding_date.filter(
              (item) => item !== value,
            ),
        });
      } else {
        this.$store.dispatch(EMatchingSearchActions.SET_FILTERS, {
          ...this.$store.state.matchingSearch.filters,
          founding_date: [
            ...this.$store.state.matchingSearch.filters.founding_date,
            value,
          ],
        });
      }

      const result = await this.$store.dispatch(
        EMatchingSearchActions.SEARCH,
        "search",
      );
      this.$emitter.emit("search-completed", { status: result });
    },
  },
});
</script>

<style lang="scss">
.matching-filters {
  margin-top: 6px;

  @include breakpoint-up(md) {
    position: relative;
    // top: -34px;
    right: 1px;
  }
}

.matching-filters__filters-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  width: 100%;
}

.matching-filters__filters-title {
  line-height: 16px;
  font-size: 0.86rem;
  font-weight: 600;
  color: #8b8fa1;
  margin-right: 16px;
}

.matching-filters__filters-wrapper .el-tag .el-tag__content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.mathcing-filters__filters-count {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  text-align: center;
  line-height: 16px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #2e2e2e;
  background-color: #fafafa;
}

.matching-filters__search-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;

  .el-tag {
    padding-top: 10px;
    padding-bottom: 10px;
    margin-top: -4px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

.matching-filters__search {
  position: relative;
  flex: 1 1 50%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  font-size: 14px;
  color: $gun-powder;
  background-color: #f0f1f5;

  @include breakpoint-down(md) {
    left: 1px;
  }

  @include breakpoint-up(md) {
    top: -3px;
    flex: 0 0 310px;
    margin-left: 0;
  }

  .el-input__inner {
    height: 40px;
    padding-left: 16px;
    margin-right: 40px;
    color: $manatee;
    letter-spacing: -0.4px;
  }
}

.matching-filters__search .el-input__suffix {
  top: 14px;
  right: 15px;

  .el-input__suffix-inner {
    border: none;

    .el-input__icon {
      width: 13px;
      height: 13px;
      cursor: pointer;
      background: transparent url("#{$assetsPath}/img/icons/cross.svg")
        no-repeat;
      background-size: contain;
      transition: $--filter-transition-base;

      &:hover {
        filter: brightness(50%);
      }
    }
  }
}

.matching-filters--closed {
  margin-bottom: 6px;
}

.matching-filters__label {
  padding-top: 9px;
  padding-right: 11px;

  span {
    @include grotesk(semiBold);

    display: inline-block;
    font-size: 12px;
    text-transform: uppercase;
    vertical-align: middle;
  }

  .matching-filters__tooltip-icon {
    margin-left: 7px;
    vertical-align: middle;
  }
}

.matching-filters__toggle-wrapper {
  display: flex;
  flex-direction: row;
  gap: 8px;
  // justify-content: flex-end;
  justify-content: space-between;
  max-height: 33px;
  // margin-bottom: 16px;

  .matching-filters--closed & {
    margin-bottom: 0;
  }
}

.matching-filters__toggle-button.el-button {
  min-width: 36px;
  height: 36px;
  padding: 0 10px;
  margin: 2px 1px 11px 12px;

  @include breakpoint-up(md) {
    min-width: 91px;
    height: 33px;
    padding: 0 10px 0 13px;
    margin: 0 0 11px 12px;
  }

  span {
    position: relative;
    top: 0;
  }

  &.has-filters {
    min-width: 56px;
  }

  &:not(.is-active) {
    @include breakpoint-up(md) {
      margin-bottom: 0;
    }
  }

  & + & {
    // Reduce margin between same elements
    margin-left: 8px;
  }
}

.matching-filters__toggle-icon:not(:only-child) {
  margin-right: 4px;
}

.matching-filters__wrapper .el-form-item__content {
  @include breakpoint-up(md) {
    display: flex;
    flex-flow: row wrap;
  }
}

.matching-filters__selector {
  display: flex;
  flex: 1 1 50%;
  flex-direction: row-reverse;

  .networks-selector__select {
    flex: 0 0 auto;
    width: 270px;
  }

  .networks-selector__select .el-input__inner {
    height: 40px;
  }

  .networks-selector__title {
    padding-top: 4px;
    margin-bottom: 0;
  }

  .networks-selector__list {
    display: flex;
    flex: 1 1 70%;
    flex-flow: row wrap;
    margin-bottom: 0;
    margin-left: 12px;
  }

  .networks-selector__wrapper {
    display: flex;
    flex-flow: row wrap;
    align-items: baseline;
  }

  .networks-selector__entry,
  .networks-selector__entry:last-child {
    box-sizing: border-box;
    height: 40px;
    margin-bottom: 12px;
  }

  .networks-selector__entry:not(:last-child) {
    margin-right: 12px;
  }

  .networks-selector__entry-picture {
    display: none;
  }

  .networks-selector__entry-content {
    padding-right: 15px;
    line-height: 24px;
  }

  .networks-selector__entry-content span {
    font-size: 14px;
  }
}

.matching-filters__tooltip {
  width: 250px;
}
</style>

<style lang="scss">
.slider-demo-block {
  width: 300px;
  display: flex;
  align-items: center;
}

.slider-demo-block .el-slider {
  width: 100%;
  margin-top: 0;
  margin-left: 12px;
}

.slider-demo-block .el-slider__marks {
  font-size: 12px;
  padding-top: 12px;
}

slider-demo-block .el-popper {
  background-color: #ffffff;
  padding: 4px;
  border-radius: 4px;
}

.slider-demo-block .el-slider__bar,
.slider-demo-block .el-slider__button {
  background-color: #225da5;
}

.slider-demo-block .el-slider__button-wrapper {
  top: -5px;
}

.slider-demo-block .el-slider__button {
  border-color: #225da5;
}

.slider-demo-block .el-slider__marks {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
</style>
